export const requireNonUndefined = <T>(object: T | undefined | null, message: string): T => {
  isTrue(object == undefined, message);
  return object!;
};

export const notUndefined = (object: any, message: string): void => {
  isTrue(object == undefined, message);
};

export const notBlank = (string: string | undefined, message: string): void => {
  isTrue(string == undefined || string.trim().length == 0, message);
};

export const notEmpty = (collection: Array<any> | Map<any, any>, message?: string) => {
  const isUndefined = collection == undefined;
  const isEmptyArray = collection instanceof Array && (collection as Array<any>).length == 0;
  const isEmptyMap = collection instanceof Map && (collection as Map<any, any>).size == 0;
  isTrue(isUndefined || isEmptyArray || isEmptyMap, message);
};

export const isTrue = (condition: boolean, message?: string): void => {
  if (condition) {
    throwError(message);
  }
};

const throwError = (message?: string): void => {
  if (message != undefined && message.length != 0) {
    throw new Error(message);
  } else {
    throw new Error();
  }
};
